
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HelpButton extends Vue {
    @Prop() private id!: string;
    @Prop() private title!: string;

}
